import { net_common } from "@/api/http";
// 「データ管理の達人」からのインポート画面表示
export const API_DisplayCubeBopImport = (...params) =>
  net_common.post("/api/STDSDC01C19/DisplayCubeBopImport", ...params);
// 接続先データベース変更
export const API_ChangeCubeBopDatabase = (...params) =>
  net_common.post("/api/STDSDC01C19/ChangeCubeBopDatabase", ...params);
// 事業者情報インポート
export const API_ImportCubeBopInfo = (...params) =>
  net_common.post("/api/STDSDC01C19/ImportCubeBopInfo", ...params);